import { useLocalStorage } from 'usehooks-ts'

import { useFvNavigate } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { useLoadEditRoute } from '@/route-hooks'

export function useRepeatShipment(shipment: FullShipment) {
  const navigate = useFvNavigate()
  const editRoute = useLoadEditRoute()
  const [, setTemplate] = useQuoteRequestTemplate()

  return function repeatShipment() {
    setTemplate([shipment])
    navigate(editRoute(shipment, 'copy'))
  }
}

export const useQuoteRequestTemplate = () => {
  return useLocalStorage<FullShipment[] | null>('quoteRequestTemplate', null)
}
